import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';
import { CaptionText, H3, P2 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { colors } from '../../../styles/GlobalStyles';
import { NodeImage, NodeStyled } from './Node.styled';

export const Node = ({
  id,
  image,
  title,
  price,
  priceToShow,
  selectedLicence,
  condensed,
  currency,
  includesSubscription,
  subscriptionPrice,
  showTickets
}: any) => {
  return (
    <NodeStyled>
      <div>
        <NodeImage condensed={condensed} image={image} />

        <Flexed column between>
          <div>
            <H3 mb='4'>{title}</H3>

            {priceToShow ? (
              <P2 color={colors.neutral900}>{priceToShow}</P2>
            ) : subscriptionPrice ? (
              <>
                <P2 color={colors.neutral900}>
                  {formatUSDNoDecimals(price)} {currency || USDT} Membership
                </P2>
                <P2 color={colors.neutral900}>
                  {formatUSDNoDecimals(subscriptionPrice)} {currency || USDT}{' '}
                  Subscription
                </P2>
                {selectedLicence && (
                  <P2 color={colors.neutral900}>
                    {formatUSDNoDecimals(selectedLicence.price)}{' '}
                    {currency || USDT} BO subscription
                  </P2>
                )}
              </>
            ) : (
              <P2 color={colors.neutral900}>
                {formatUSDNoDecimals(price)} {currency || USDT}{' '}
                {`${(id > 220 && id < 225) || id === 1 ? 'yearly' : ''} `}
              </P2>
            )}
          </div>
        </Flexed>
      </div>
    </NodeStyled>
  );
};
